import { render, staticRenderFns } from "./DashboardTabs.vue?vue&type=template&id=5b499f2a&scoped=true"
import script from "./DashboardTabs.vue?vue&type=script&lang=js"
export * from "./DashboardTabs.vue?vue&type=script&lang=js"
import style0 from "./DashboardTabs.vue?vue&type=style&index=0&id=5b499f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b499f2a",
  null
  
)

export default component.exports